<template>
  <section class="site-section">
    <h2><AppIcon name="send" />网站列表</h2>
    <div class="site-grid">
      <a
        v-for="item in siteLinks"
        :key="item.title"
        class="site-card"
        :href="item.url"
        :target="item.target || '_blank'"
        rel="noopener noreferrer"
      >
        <AppIcon :name="item.icon" />
        <strong>{{ item.title }}</strong>
        <span>{{ item.description }}</span>
      </a>
    </div>
  </section>
</template>

<script>
import AppIcon from './AppIcon.vue';

export default {
  name: 'SiteGrid',
  components: { AppIcon },
  props: {
    siteLinks: {
      type: Array,
      default: () => []
    }
  }
};
</script>
